export const parseCookies = (cookieHeader = ''): Record<string, string> => {
  const cookies: Record<string, string> = {};
  cookieHeader.split(';').forEach((cookieString) => {
    const [name, value] = cookieString.split('=');
    if (name && value) {
      cookies[name.trim()] = value.trim();
    }
  });
  return cookies;
};
